export function mensagemAlteracoesNaoSalvas() {
  return "Existem alterações que não foram salvas na tela. Tem certeza de que deseja sair sem salvar?";
}
export function mensagemPadraoExclusao() {
  return "Você realmente deseja excluir?";
}
